// Centralized categories configuration
// System emojis can be overridden by admin
// User custom emojis take precedence over system emojis

export const DEFAULT_CATEGORIES = [
  { id: 'logement', emoji: '🏠', name_fr: 'Logement', name_en: 'Housing', name_pt: 'Habitação' },
  { id: 'alimentation', emoji: '🍕', name_fr: 'Alimentation', name_en: 'Food', name_pt: 'Alimentação' },
  { id: 'transport', emoji: '🚗', name_fr: 'Transport', name_en: 'Transport', name_pt: 'Transporte' },
  { id: 'sante', emoji: '💊', name_fr: 'Santé', name_en: 'Health', name_pt: 'Saúde' },
  { id: 'loisirs', emoji: '🎮', name_fr: 'Loisirs', name_en: 'Entertainment', name_pt: 'Lazer' },
  { id: 'shopping', emoji: '🛍️', name_fr: 'Shopping', name_en: 'Shopping', name_pt: 'Compras' },
  { id: 'restaurant', emoji: '🍽️', name_fr: 'Restaurant', name_en: 'Restaurant', name_pt: 'Restaurante' },
  { id: 'abonnements', emoji: '📱', name_fr: 'Abonnements', name_en: 'Subscriptions', name_pt: 'Assinaturas' },
  { id: 'education', emoji: '📚', name_fr: 'Éducation', name_en: 'Education', name_pt: 'Educação' },
  { id: 'epargne', emoji: '🐷', name_fr: 'Épargne', name_en: 'Savings', name_pt: 'Poupança' },
  { id: 'investissements', emoji: '📈', name_fr: 'Investissements', name_en: 'Investments', name_pt: 'Investimentos' },
  { id: 'cadeaux', emoji: '🎁', name_fr: 'Cadeaux', name_en: 'Gifts', name_pt: 'Presentes' },
  { id: 'vacances', emoji: '✈️', name_fr: 'Vacances', name_en: 'Vacation', name_pt: 'Férias' },
  { id: 'animaux', emoji: '🐕', name_fr: 'Animaux', name_en: 'Pets', name_pt: 'Animais' },
  { id: 'services', emoji: '🔧', name_fr: 'Services', name_en: 'Services', name_pt: 'Serviços' },
  { id: 'impots', emoji: '🏛️', name_fr: 'Impôts', name_en: 'Taxes', name_pt: 'Impostos' },
  { id: 'assurance', emoji: '🛡️', name_fr: 'Assurance', name_en: 'Insurance', name_pt: 'Seguro' },
  { id: 'divers', emoji: '📦', name_fr: 'Divers', name_en: 'Miscellaneous', name_pt: 'Diversos' },
];

// Popular emojis for user selection
export const EMOJI_OPTIONS = [
  // Money & Finance
  '💰', '💵', '💳', '🏦', '📈', '📉', '💎', '🪙', '🐷',
  // Home & Living
  '🏠', '🏡', '🛋️', '🛏️', '🚿', '🔑', '🪴', '💡', '🔌',
  // Food & Drink
  '🍕', '🍔', '🍜', '🥗', '🍳', '☕', '🍷', '🛒', '🍽️',
  // Transport
  '🚗', '🚌', '🚇', '✈️', '⛽', '🚲', '🛵', '🚕', '🚂',
  // Health & Wellness
  '💊', '🏥', '💪', '🧘', '🏃', '❤️', '🩺', '💉', '🦷',
  // Entertainment
  '🎮', '🎬', '🎵', '📺', '🎭', '🎨', '📖', '🎯', '🎪',
  // Shopping
  '🛍️', '👗', '👟', '💄', '⌚', '💍', '🎁', '📱', '💻',
  // Education
  '📚', '🎓', '✏️', '📝', '🔬', '🌍', '💼', '📊', '🖥️',
  // Family & Social
  '👨‍👩‍👧‍👦', '👶', '🐕', '🐈', '🎂', '🎉', '💒', '🏖️', '⛺',
  // Services & Bills
  '📞', '📧', '🔧', '🛠️', '🏛️', '🛡️', '📋', '🔒', '⚡',
  // Nature & Weather
  '🌳', '🌸', '☀️', '🌙', '⭐', '🌈', '❄️', '🔥', '💧',
  // Other
  '✨', '🎯', '📦', '🏷️', '⚙️', '🔔', '📌', '🎪', '🌟',
];

// Get category with user customization support
export function getCategoryInfo(categoryId, userCustomEmojis = {}, systemEmojis = {}, language = 'fr') {
  const defaultCat = DEFAULT_CATEGORIES.find(c => c.id === categoryId);
  
  if (!defaultCat) {
    // Custom category created by user
    return {
      id: categoryId,
      emoji: userCustomEmojis[categoryId] || '📦',
      name: categoryId
    };
  }
  
  // Priority: User custom emoji > System emoji (admin) > Default emoji
  const emoji = userCustomEmojis[categoryId] || systemEmojis[categoryId] || defaultCat.emoji;
  const name = defaultCat[`name_${language}`] || defaultCat.name_fr;
  
  return {
    id: defaultCat.id,
    emoji,
    name
  };
}

// Get all categories with proper emojis
export function getAllCategories(userCustomEmojis = {}, systemEmojis = {}, language = 'fr') {
  return DEFAULT_CATEGORIES.map(cat => getCategoryInfo(cat.id, userCustomEmojis, systemEmojis, language));
}
